import { render, staticRenderFns } from "./DerBodyModule.vue?vue&type=template&id=62a2dcd4&"
import script from "./DerBodyModule.ts?vue&type=script&lang=ts&"
export * from "./DerBodyModule.ts?vue&type=script&lang=ts&"
import style0 from "./DerBodyModule.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports